// extracted by mini-css-extract-plugin
export default {"tooltip":"xV-z","arrow":"yV-z"};